import { render, staticRenderFns } from "./stdFixed.vue?vue&type=template&id=62a85f60&scoped=true"
import script from "./stdFixed.vue?vue&type=script&lang=js"
export * from "./stdFixed.vue?vue&type=script&lang=js"
import style0 from "./stdFixed.vue?vue&type=style&index=0&id=62a85f60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a85f60",
  null
  
)

export default component.exports